import React from "react";
import { useHistory } from "react-router-dom";
import Button from "../../UI/Button";

const About = () => {
  const history = useHistory();

  const handleGoHomeClick = () => {
    history.push("/");
  };

  return (
    <div className="my-4 w-full flex flex-col justify-center items-center">
      <ul className="mt-4 text-lg sm:text-xl list-disc w-3/4">
        <li className="mb-1">
          A person needs to allow camera and audio permissions from the site
          information icon. <span className="text-red-400">(Required)</span>
        </li>
        <li className="mb-1">
          A person must setup his profile (name and robot avatar) before
          continuing to main app.{" "}
          <span className="text-red-400">(Required)</span>
        </li>
        <li className="mb-1">
          2 people can video call each other with each others id.
        </li>
        <li className="mb-1">
          Each one of them can use all call features and update their profiles.
        </li>
        <li className="mb-1">
          {" "}
          <span className="text-red-400">Disclaimer:</span> A person cannot call
          themselves with the same meeting id.
        </li>
      </ul>

      <h3 className="mt-8 text-xl sm:text-2xl cursor-pointer border-b-4 border-green-700">
        How to Call Yourself?
      </h3>

      <ul className="mt-4 text-lg sm:text-xl list-decimal w-3/4">
        <li className="mb-1">Open 2x browser tabs.</li>
        <li className="mb-1">
          Copy meeting id from one tab and then use that in the second tab.
        </li>
        <li className="mb-1">Make the call.</li>
      </ul>

      <Button
        className="bg-green-700 whitespace-nowrap w-min mt-8"
        onClick={handleGoHomeClick}
      >
        Back Home
      </Button>
    </div>
  );
};

export default About;
